import { track } from '../../vendor/splitmetrics-track/index';



export const EVENT_NAME = 'apple_tv_gallery_slide_close';


export default (params) => {
  track(EVENT_NAME, params, {});
};



// WEBPACK FOOTER //
// ./src/lib/track-event/apple-tv-gallery-slide-close.js